import type { InjectionKey } from 'vue';

export const LINK_TYPES_IDS: InjectionKey<() => Promise<number[]>> = Symbol('link-types-ids');
